export { SLHomeComponent } from './sl-home.component';
export { SLModule } from './shares-ledger.module'

export function isSLFeatureEnabled() {
  return process.env.FEATURE_SL_ENABLED === 'yes';
}
